// extracted by mini-css-extract-plugin
export default {"centersTable":"centers-table_centersTable__yiGEU","sortIcons":"centers-table_sortIcons__MJK62"};